import common from './common';
import meta from './meta';

export default { ...common, meta }
